import { PrimeReactPTOptions } from "primereact/api";
import { DropdownPassThroughMethodOptions } from "primereact/dropdown";
import { classNames } from "primereact/utils";

import { focusedField, focusHoverField, invalidField, placeholder } from "./common";

export const dropdown: PrimeReactPTOptions["dropdown"] = {
  root: ({ props, state }: DropdownPassThroughMethodOptions) => {
    return {
      className: classNames(
        "cursor-pointer inline-flex relative select-none",
        "transition-colors duration-200 ease-in-out rounded-md",
        "dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300",
        "w-full md:w-full h-[40px]",
        "border border-urbe-border bg-white",
        "text-urbe-gray text-sm",
        placeholder,
        "placeholder:not-italic",
        focusHoverField,
        {
          "bg-urbe-grayLight text-urbe-textSecondary select-none pointer-events-none cursor-default":
            props.disabled,
          [focusedField]: state.focused,
          [invalidField]: props?.invalid,
          "bg-urbe-primaryLight": props.variant === "filled",
        },
      ),
    };
  },
  input: ({ props }: DropdownPassThroughMethodOptions) => ({
    className: classNames(
      "cursor-pointer block flex flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap relative",
      "bg-transparent border-0",
      "dark:text-white/80",
      "h-[40px] text-sm",
      "py-2 px-3 transition duration-200 bg-transparent rounded appearance-none",
      "focus:outline-none focus:shadow-none",
      { "pr-7": props.showClear },
    ),
  }),
  trigger: {
    className: classNames(
      "flex items-center justify-center shrink-0 p-dropdown-trigger",
      "bg-transparent text-urbe-border w-12 rounded-tr-lg rounded-br-lg",
    ),
  },
  wrapper: {
    className:
      "max-h-[200px] overflow-auto bg-white rounded-md shadow-lg dark:bg-gray-900 dark:text-white/80",
  },
  panel: {
    className: "mt-1 border border-gray-200 rounded",
  },
  list: () => "list-none m-0",
  item: ({ context }: DropdownPassThroughMethodOptions) => {
    return {
      className: classNames(
        "cursor-pointer font-normal overflow-hidden relative whitespace-nowrap",
        "m-0 px-3 py-2 pl-6 border-0  transition-shadow duration-200 rounded-none",
        "text-sm",
        {
          "text-urbe-text hover:text-gray-700 hover:bg-rdc-primaryLight dark:text-white/80 dark:hover:bg-gray-800":
            !context.focused && !context.selected,
          "bg-rdc-primaryLight text-gray-700 dark:text-white/80 dark:bg-gray-800/90 hover:text-gray-700 hover:bg-gray-200 dark:text-white/80 dark:hover:bg-gray-800":
            context.focused && !context.selected,
          "bg-rdc-primaryLight text-rdc-primary dark:bg-blue-400 dark:text-white/80":
            context.focused && context.selected,
          "bg-rdc-primaryLight text-rdc-primary dark:bg-blue-300 dark:text-white/80":
            !context.focused && context.selected,
          "opacity-60 select-none pointer-events-none cursor-default": context.disabled,
        },
      ),
    };
  },
  itemGroup: {
    className: classNames(
      "m-0 p-3 text-gray-800 bg-white font-bold",
      "dark:bg-gray-900 dark:text-white/80",
      "cursor-auto",
    ),
  },
  header: {
    className: classNames(
      "p-3 bg-white mt-0 rounded-tl-lg rounded-tr-lg",
      "dark:bg-gray-800 dark:text-white/80 dark:border-blue-900/40",
    ),
  },
  filterContainer: () => "relative",
  filterInput: {
    className: classNames(
      "pr-7 ",
      "w-full h-[35px]",
      "font-sans text-base text-gray-700 bg-white py-1 px-3 border border-gray-300 transition duration-200 rounded-lg appearance-none",
      "dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80",
      "hover:border-gray-300 focus:outline-none focus:outline-offset-0 focus:border-gray-300 dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]",
    ),
    placeholder: "Buscar",
    autoFocus: true,
  },
  emptyMessage: {
    className: "text-gray-600 p-2",
  },
  filterIcon: () => "absolute top-1/2 right-2 stroke-gray-300",
  clearIcon: () => "text-urbe-border w-[12px] right-12 -mt-[7px] absolute top-1/2",
};
